import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'peps-coins-badge',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './coins-badge.component.html',
})
export class CoinsBadgeComponent {
	@Input() coins = 0;
}
